import AppState from './statelogic'
import Routes2 from './routes2'
const SocketState2 = new AppState(Routes2)
export default SocketState2